import React, { Component } from "react";
import {
  Avatar,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  DialogContentText,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, Drawer } from "@material-ui/core";
import { styles } from "./User.css";
import i18n from "i18next";
import MmButton from "util/MmButton";
import LanguageSelect from "../language-select/LanguageSelect";
import { SET_USER_PERMISSION } from "../../redux/Types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditIcon from "@material-ui/icons/Edit";
import MessagesWrap from "../../modules/messages/MessagesWrap";
import { uploadProfileImage } from "../../redux/actions/ImageActions";
import {
  postItem,
  clearProfileImage,
  clearMessage,
  setMessage,
} from "../../redux/actions/MlAdminUserActions";
import { helpModules } from "../../modules/ml-admin/help-admin/help-view/Const";
import HelpWrap from "../../modules/ml-admin/help-admin/help-view/HelpWrap";
import {
  getHelpData,
  setDrawerOpen,
} from "../../modules/ml-admin/help-admin/redux/HelpActions";
import {
  setLinkwithContentRequest,
  linkCRequestSearch,
} from "../../modules//ml-content-tracker/content-request/redux/ContentRequestActions";
import {
  setEditMessageCB,
  editMessage,
} from "../../modules/messages/redux/MessagesActions";
import HelpMain from "../../modules/ml-admin/help-admin/help-view/HelpMain";
import { withRouter } from "react-router-dom";
import LinkContentRequest from "../../modules/ml-content-tracker/content-request/link-content-request/LinkContentRequest";
import { logoutUser, removeUserImage } from "../../redux/actions/UserActions";
import store from "redux/Store";
import clsx from "clsx";
import DeleteIcon from '@material-ui/icons/Delete';
import GroupDisplay from "util/GroupDisplay";


class User extends Component {
  constructor(props) {
    super();
    this.state = {
      open: false,
      lang: i18n.language || "en",
      messageOpen: false,
      uploadingProfileImage: false,
      profileImageUploaded: false,
    };
  }

  isValidPhoto = (fileName) => {
    var allowed_extensions = new Array("jpg", "png", "jpeg");
    var file_extension = fileName.split(".").pop().toLowerCase();

    for (var i = 0; i <= allowed_extensions.length; i++) {
      if (allowed_extensions[i] == file_extension) {
        return true; // valid file extension
      }
    }
    return false;
  };

  handleImageChange = (event) => {
    const { user, clearMessage, setMessage } = this.props;
    if (event.target.files.length > 0) {
      const image = event.target.files[0];
      console.log(
        "ProfileImageUpload",
        "AddEditUser",
        "uploadProfileImage",
        "has image"
      );
      if (this.isValidPhoto(image.name)) {
        console.log(
          "ProfileImageUpload",
          "AddEditUser",
          "uploadProfileImage",
          "valid image"
        );
        const formData = new FormData();
        formData.append("image", image, image.name);
        formData.append("to", "orgUsers");
        formData.append("id", user.id);
        this.setState({
          uploadingProfileImage: true,
        });
        console.log(
          "ProfileImageUpload",
          "AddEditUser",
          "uploadProfileImage",
          "sent to upload image"
        );
        this.props.uploadProfileImage(formData, (url, error) => {
          this.setState({
            uploadingProfileImage: false,
          });
          if (url) {
            console.log(
              "ProfileImageUpload",
              "AddEditUser",
              "uploadProfileImage",
              "image uploaded successfully"
            );
            this.setState({
              profileImageUploaded: true,
            });
            setTimeout(() => {
              this.setState({
                profileImageUploaded: false,
              });
            }, 1000);
          }
          if (error) {
            console.error(
              "ProfileImageUpload",
              "User",
              "uploadProfileImage",
              [formData],
              error
            );
          }
        });
      } else {
        document.getElementById("imageInputUser").value = null;
        setMessage("File type not allowed");
        setTimeout(() => {
          clearMessage("");
        }, 1000);
        console.error(
          "ProfileImageUpload",
          "User",
          "handleImageChange",
          "File type not allowed",
          [image]
        );
      }
    } else {
      console.error(
        "ProfileImageUpload",
        "User",
        "handleImageChange",
        "File not selected"
      );
    }
  };

  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInputUser");
    fileInput.click();
  };

  handleRemoveImage = () => {
    const {
      postItem,
      user: {
        credentials: { orgs, orgID },
      },
      data: { editing },
      clearProfileImage,
      clearMessage,
      removeUserImage,
    } = this.props;
    const { userId } = orgID ? orgs.find((v) => v.id === orgID) : {};
    postItem(
      "removeprofileimage",
      `removing image in progress ...`,
      [userId],
      (data, error) => {
        if (data) {
          if (editing) {
            clearProfileImage(null);
          }
          clearMessage("");
          removeUserImage(null);
          document.getElementById("imageInputUser").value = null;
        }
      }
    );
  };

  handleSignoutConfirmation = (e) => {
    const {
      sessionData: { uploadQueue },
      logoutUser,
    } = this.props;

    if (uploadQueue.length > 0) {
      this.setState({ messageOpen: true });
    } else {
      logoutUser();
    }
  };

  handleSignout = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const { logoutUser } = this.props;
    logoutUser();
  };

  handleCloseMessage = () => {
    this.setState({ messageOpen: false });
  };

  handleOpen = () => {
    this.setState({
      open: true,
      orgID:
        this.props.user && this.props.user.credentials
          ? this.props.user.credentials.orgID || ""
          : "",
    });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  dispatchToUser = (id) => {
    let cred = this.props.user.credentials;
    cred.orgID = id;

    store.dispatch({
      type: SET_USER_PERMISSION,
      payload: cred,
    });
  };

  handleChange = (id) => {
    this.setState(
      {
        orgID: id,
      },
      () => {
        this.dispatchToUser(this.state.orgID);
      }
    );
  };

  handlehelpClose = () => {
    const {
      setDrawerOpen,
      help: { cConfig },
      getHelpData,
    } = this.props;
    // this.setState({ open: false },()=>{
    setDrawerOpen(false, null);
    getHelpData(cConfig, "", "");
    // });
  };

  handleCloseCRequestLink = () => {
    const {} = this.props;
  };

  render() {
    const {
      classes,
      user,
      user: {
        credentials: { orgs, orgID },
      },
      data: {
        posting: { busy, message },
      },
      help: { drawerOpen, cConfig },
      location: { search, pathname },
      contentRequest: { linkContentMsg },
      messages: {
        posting: { busy: contentRequestBusy, message: contentRequestMessage },
      },
    } = this.props;

    const { messageOpen } = this.state;

    const { firstName, lastName, imageUrl, email } = user;
    const { role, groups } = orgID ? orgs.find((v) => v.id === orgID) : {};

    return (
      <Translation>
        {(t, { i18n }) => (
          <div className={classes.userMainWrap}>
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={
                (busy && message) ||
                (contentRequestBusy && contentRequestMessage)
                  ? true
                  : false
              }
              message={message || contentRequestMessage}
              className={classes.snackbar}
            />
            <Dialog
              open={messageOpen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.dialogWrapper}
              class="dialogBox"
            >
              <DialogTitle id="alert-dialog-title">
                {"Confirmation Alert"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Typography gutterBottom>
                    Are you sure want to signout?
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="primary"
                  className={classes.dialogYesButton}
                  autoFocus
                  onClick={(e) => this.handleSignout(e)}
                >
                  Yes
                </Button>
                <Button
                  autoFocus
                  className={classes.dialogNoButton}
                  onClick={this.handleCloseMessage}
                  color="primary"
                >
                  no
                </Button>
              </DialogActions>
            </Dialog>

            {(search && search.includes("?uploadTracks") || pathname && pathname.includes("/downloader/")) ? null : (
              <>
                <div id="help-header-area" className={classes.usersHelpButton}>
                  <HelpWrap config={helpModules.general} />
                </div>
                <div
                 id="message-header-area"
                  style={{ marginRight: "10px" }}
                  className={classes.usersMessageButton}
                >
                  <MessagesWrap setOpen={open => this.messageOpen = open}/>
                </div>
              </>
            )}

            <div
              style={{ display: "none" }}
              className={(classes.mainwrap, classes.square)}
            >
              {orgID ? (
                <>
                  {/* <div>
                   <div className={classes.userOrganization}>BBC Promos</div>
                   <div className={classes.userRole}>{name}</div>
                 </div> */}
                </>
              ) : (
                <>Global</>
              )}
            </div>
            <div id="user-info-header-area" className={(classes.mainwrap, classes.buttonSquare)}>
              <MmButton
                className={classes.buttonSquare}
                onClick={this.handleOpen}
                tip="User settings"
              >
                <div id="user-header-area" className={classes.userArea}>
                  <Avatar
                    className={classes.userIcon}
                    alt={firstName}
                    src={imageUrl}
                  />
                  <div>
                    <span title={firstName} className={classes.firstName}>
                      {firstName}
                    </span>
                    <span title={role} className={classes.userRole}>
                      {role}
                    </span>{" "}
                  </div>
                  <ExpandMoreIcon />
                </div>
              </MmButton>
            </div>

            <Drawer
              key="edituser"
              anchor="right"
              open={this.state.open}
              onClose={this.handleClose}
            >
              <div id="user-info-side-bar" className={classes.panelWidth}>
                <div className={classes.userEdit}>
                  <Avatar
                    alt={firstName}
                    className={classes.viewUser}
                    src={imageUrl}
                  >
                    {firstName}
                  </Avatar>

                  <input
                    type="file"
                    id="imageInputUser"
                    hidden="hidden"
                    aria-label="userImageInput"
                    onChange={this.handleImageChange}
                  />
                  <span className={classes.editIcon}>
                    <MmButton
                      className={classes.editIcon}
                      tip="Add / Edit profile picture"
                      onClick={this.handleEditPicture}
                      btnClassName="button"
                    >
                      <EditIcon color="primary" />
                    </MmButton>
                  </span>
                  <span className={classes.deleteIcon}>
                    {imageUrl && (
                      <MmButton
                        className={classes.deleteIcon}
                        tip="Remove profile picture"
                        onClick={this.handleRemoveImage}
                        btnClassName="button"
                      >
                        <DeleteIcon color="primary" />
                      </MmButton>
                    )}
                  </span>
                  {this.state.uploadingProfileImage && (
                    <CircularProgress className={classes.profileLoader} />
                  )}
                  {this.state.profileImageUploaded && (
                    <span className={classes.profileSaved}>
                      Profile Image Saved
                    </span>
                  )}
                </div>

                <div className={classes.userSignOut}>
                  <Button
                    className={classes.userSignOut}
                    color="inherit"
                    onClick={(e) => {
                      window.location.replace(`/logoutwithredirect`);
                    }}
                  >
                    Sign out
                  </Button>
                </div>

                <div className={classes.mainListWrap}>
                  <div className={classes.muDetailWrap}>
                    <span title="Email" className={classes.muLabels}>
                      Email{" "}
                    </span>
                    <span className={classes.muSeperator}> :</span>
                    <span className={classes.muDetails}>{user.email}</span>
                  </div>
                  <div className={classes.muDetailWrap}>
                    <span title="Name" className={classes.muLabels}>
                      Name
                    </span>{" "}
                    <span className={classes.muSeperator}> :</span>
                    <span className={classes.muDetails}>
                      {firstName} {""} {lastName}
                    </span>
                  </div>
                  <div className={classes.muDetailWrap}>
                    <span title="Role" className={classes.muLabels}>
                      Role{" "}
                    </span>
                    <span className={classes.muSeperator}> :</span>
                    <span className={classes.muDetails}>{role}</span>
                  </div>
                  <div className={classes.muDetailWrap}>
                    <span title="Groups" className={classes.muLabels}>
                      Groups{" "}
                    </span>
                    <span className={classes.muSeperator}> :</span>
                    <span className={classes.muDetails}><GroupDisplay classes={classes} groupId={groups} /></span>
                  </div>

                  {/* <div className={classes.muDetailWrap}>
                    <span title="Language" className={classes.muLabels}>Language<span className={classes.muSeperator}> :</span></span>
                    <span className={classes.muDetails}>
                      <div className={classes.userLanguage}>
                        <LanguageSelect />
                      </div>
                    </span>
                  </div> */}


                  {/* commented on 16/10/2023 - Ticket : https://soundmouse-jira.atlassian.net/browse/ML20-3759 */}
                  {/* <div className={classes.orgDetails}>
                    <span
                      title="Organizations"
                      className={clsx(classes.orgListName, classes.muLabels)}
                    >
                      Organizations
                    </span>

                    <span className={classes.orgList}>
                      <div className={classes.orgListItems}>
                        {orgs.map((v) => (
                          <>
                            <MenuItem
                              //onClick={() => this.handleChange(v.id)}
                              key={v.id}
                              value={v.id}
                              //disabled={this.state.orgID == v.id ? true : false}
                              className={
                                this.state.orgID == v.id
                                  ? classes.selected
                                  : classes.notSelected
                              }
                            >
                              <a
                                href={
                                  "https://" +
                                  v.id +
                                  "." +
                                  appConfig.MB_DOMAIN +
                                  "/tourl?url=&origin=" +
                                  orgID +
                                  "." +
                                  appConfig.MB_DOMAIN +
                                  "&org=" +
                                  encodeURIComponent(btoa(v.id)) +
                                  "&user=" +
                                  encodeURIComponent(btoa(email))
                                }
                                // href={
                                //   "http://localhost:3001/tourl?url=/playlist/d7d876e9-b296-4ae8-b774-709ae364a1b3&origin=http://localhost:3000&user=" +
                                //   encodeURIComponent(btoa(email)) +
                                //   "&org=" +
                                //   encodeURIComponent(btoa(v.id))
                                // }
                              >
                                <Avatar
                                  alt={v.name}
                                  className={classes.userWorkspaceImage}
                                  variant="square"
                                  src={v.orgImageUrl}
                                >
                                  {v.name}
                                </Avatar>
                                {v.name}
                              </a>
                            </MenuItem>
                          </>
                        ))}
                      </div>
                    </span>
                  </div> */}

                  {/* <TextElement label="ID" classes={classes} data={user.id} /> */}
                  {/* <TextElement
                    label="eMail"
                    classes={classes}
                    data={user.email}
                  /> */}
                  {/* <TextElement
                    label="Name"
                    classes={classes}
                    data={user.name}
                  />
                  <DateTimeElement
                    label="Created At"
                    classes={classes}
                    data={user.createdAt}
                  />
                  <DateTimeElement
                    label="Updated At"
                    classes={classes}
                    data={user.updatedAt}
                  /> */}
                </div>
              </div>
            </Drawer>

            <Drawer
              variant="persistent"
              key="help"
              anchor="right"
              open={drawerOpen}
              onClose={this.handlehelpClose}
              className={classes.helpDrawer}
            >
              {cConfig && (
                <HelpMain
                  {...this.props}
                  open={drawerOpen}
                  config={cConfig}
                  onClose={this.handlehelpClose}
                />
              )}
            </Drawer>

            <Drawer
              variant="persistent"
              key="contentRequestDrawer"
              anchor="right"
              open={linkContentMsg ? true : false}
            >
              {linkContentMsg && (
                <LinkContentRequest
                  {...this.props}
                  open={linkContentMsg}
                  onClose={this.handleCloseCRequestLink}
                />
              )}
            </Drawer>
          </div>
        )}
      </Translation>
    );
  }
}

User.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.mladminuser,
  messages: state.messages,
  help: state.help,
  updateData: state.mlTrackUpdateReducer,
  sessionData: state.mlUploadSession,
  contentRequest: state.contentRequest,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  uploadProfileImage,
  getHelpData,
  setDrawerOpen,
  setLinkwithContentRequest,
  linkCRequestSearch,
  setEditMessageCB,
  editMessage,
  logoutUser,
  postItem,
  clearProfileImage,
  clearMessage,
  setMessage,
  removeUserImage,
})(withStyles(styles)(withRouter(User)));
